/**
 * Created by Administrator on 2017/11/1.
 */
import {Component, OnInit} from "@angular/core";
import {API} from "../config/api-config";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {Location} from "@angular/common";
declare var alertify:any;

@Component({
  templateUrl:'./editCategory.html'
})

export class EditAboutUsCategory implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private http:HttpService,
    private fileupload:FileUpload,
    private location:Location
  ){}

  private data:any={
    'id':'',
    'nameEn':'',
    'nameTc':'',
    'imgEn':'',
    'imgTc':'',
    'urlLinkEn':'',
    'urlLinkTc':'',
    'isUrl':false
  }

  private id:number = 0;
  private imagePath:string='';
  private isCreate:boolean=false;

  private getData():void{
    this.http.getData(API.aboutUsCategory+'/'+this.id).then(res=>{
      this.data = res.data;
    })
  }

  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
      })
  }


  private submit():void{
    this.http.postData(API.aboutUsCategory,{
      'id':this.id,
      'nameEn':this.data.nameEn,
      'nameTc':this.data.nameTc,
      'imgEn':this.data.imgEn,
      'imgTc':this.data.imgTc,
      'urlLinkEn':this.data.urlLinkEn,
      'urlLinkTc':this.data.urlLinkTc,
      'isUrl':this.data.isUrl

    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });
    if(this.id!=0){
      this.getPath();
      this.getData();
    }else {
      this.isCreate=true;
    }
  }

  private showImgEn:boolean = false;
  private showImgTc:boolean = false;
  private tempPath:string=API.getTemp;
  private upload(name:string){
    let self=this;
    this.fileupload.upload(function (res) {
      let temRes=JSON.parse(res);
      if(temRes.status.code==0){
        switch (name){
          case 'imgEn':self.showImgEn=true;break;
          case 'imgTc':self.showImgTc=true;break;
        }
        self.data[name]=temRes.data.fileName;
      }else {
        alert(temRes.status.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/aboutUs/EditCategroy.component.ts